export default {
    methods: {
        showNotification(type, title, text) {
            this.$notify({
                group: 'alert',
                type: type,
                title: title,
                text: text
            });
        },
    },
};